import type { AgentMessageRevision } from "@alaffia-technology-solutions/schema";

import { PenLine } from "lucide-react";

interface EditIndicatorProps {
  revision?: AgentMessageRevision | null;
}

export function EditIndicator({ revision }: EditIndicatorProps) {
  if (!revision) {
    return null;
  }

  return (
    <div className="af-flex af-items-center af-gap-1 af-text-xs af-text-muted-foreground">
      <PenLine className="af-size-3" /> Edited
      {revision.reason ? `: ${revision.reason}` : ""}
    </div>
  );
}
